<template lang="pug">
article.card.w-100.h-100.d-flex.rounded-4
  .w-100.text-decoration-none.d-flex.h-100(@click="navigateToArticle")
    .card__inner.w-100.d-flex.flex-column
      .card__image.ratio.ratio-16x9
        nuxt-img(
          v-if='image',
          :src="image"
          :alt='`Feature image of ${title}`',
          format='webp',
          loading='lazy',
          fit="cover",
          width='530',
          height='300',
          sizes='xs:95px md:110px lg:420px xl:530px'
        )
      .card__content.h-100.gap-2.gap-md-3.d-flex.flex-column
        EcreativArchePrimitivesTime(
          :datetime="time"
          size="7"
          context="dark"
          fontWeight="normal"
          class="card-article__time"
        )
        EcreativArchetypesHeading.d-flex.flex-grow-1(
          v-if='title',
          tag='h3'
          size="6"
        )
          span(v-html='title')
        EcreativArchetypesDestinationItemArchetype.fs-7(
          componentType="InternalDestination"
          :link="getUrl"
          context="white"
          linkColor='dark'
          class="card-article__link"
          text="Read more"
        )
</template>

<script lang="ts" setup>
/* eslint-disable */
import { computed } from 'vue';
import EcreativArchePrimitivesTime from '../../arche/primitives/Time';
import EcreativArchetypesHeading from '../../archetypes/Heading';
import EcreativArchetypesDestinationItemArchetype from '../../archetypes/DestinationItemArchetype';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  link: {
    type: String,
    default: '#',
  },
  category: {
    type: String,
    default: 'articles',
  },
  time: {
    type: String,
    default: '2023-01-10',
  },
});

const getUrl = computed(() => {
  // Check if `props.category` exists and is not an empty string
  if (props.category && props.category.trim().length > 0) {
    return `${props.category}/${props.link}`;
  } else {
    // If `props.category` is not provided or is empty, construct URL without it
    return `${props.link}`;
  }
});

const navigateToArticle = () => {
  router.push(getUrl.value);
};
</script>

<style lang="scss" scoped>
.card {
  flex-direction: column;
  overflow: hidden;
  background-color: $white;
  cursor: pointer;

  &__content {
    padding: 24px;
  }
}
</style>
